import { Link } from 'react-router-dom'
import type { Document } from '@agentwiki/shared'
import { buildDocumentResultPresentation } from '../../lib/document-result-presentation'

export function DocumentReaderBreadcrumbs({
  doc,
}: {
  doc: Document
}) {
  const presentation = buildDocumentResultPresentation(doc)
  return (
    <nav className="aw-reader-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        <li>
          <Link to="/doc">Knowledge</Link>
        </li>
        <li aria-hidden="true">/</li>
        <li>{presentation.source.label}</li>
        <li aria-hidden="true">/</li>
        <li aria-current="page">{presentation.title}</li>
      </ol>
    </nav>
  )
}

export function DocumentReaderMetadata({ doc }: { doc: Document }) {
  const presentation = buildDocumentResultPresentation(doc)
  const storedDiffers = presentation.storedAuthority.key !== presentation.authority.key
  return (
    <dl className="aw-reader-metadata" aria-label="Document knowledge status">
      <div>
        <dt>Ownership</dt>
        <dd>{presentation.ownership.label}</dd>
      </div>
      <div>
        <dt>Access</dt>
        <dd>{presentation.access.label}</dd>
      </div>
      <div>
        <dt>Source</dt>
        <dd>{presentation.source.label}</dd>
      </div>
      <div>
        <dt>Authority</dt>
        <dd>
          {presentation.authority.label}
          {storedDiffers && <small>Stored {presentation.storedAuthority.label}</small>}
        </dd>
      </div>
      <div>
        <dt>Sync health</dt>
        <dd>{presentation.syncHealth.label}</dd>
      </div>
    </dl>
  )
}
